import { fetchFalckdkApi } from '../utils/fetch';

/**
 * @param {string} term - The search term
 */
export async function fetchStreetSuggestions(term) {
    try {
        const fetchResponse = await fetchFalckdkApi('/api/Autocomplete/Street', {
            params: {
                term,
            },
            method: 'GET',
        });

        const data = await fetchResponse.json();

        return data.map((item) => ({
            label: item.Text,
            value: item.Text,
            id: item.Id,
            streetname: item.Streetname,
            housenumber: item.Housenumber,
            floor: item.Floor,
            door: item.Door,
            postcode: item.Postcode,
            city: item.City,
        }));
    } catch (error) {
        console.error('Error fetching street suggestions:', error);
    }
}

/**
 * @param {string} term - The search term
 */
export async function fetchAddressById(addressId) {
    try {
        const fetchResponse = await fetchFalckdkApi('/api/Autocomplete/AddressById', {
            params: { addressId },
            method: 'GET',
        });

        const addressList = await fetchResponse.json();

        return addressList.map((item) => ({
            label: item.Text,
            value: item.Text,
            id: item.Id,
            streetname: item.Streetname,
            housenumber: item.Housenumber,
            floor: item.Floor,
            door: item.Door,
            postcode: item.Postcode,
            city: item.City,
        }));
    } catch (error) {
        console.error('Error fetching address by ID:', error);
    }
}
